/**
 * Turns a string into pascal case (eg. PascalCase)
 *
 * @param {!string} str - The string to be turned into pascalCase
 * @returns {string} - The string in pascal case
 */
const pascalCase = str => str === null || str === void 0 ? void 0 : str.replace(/(^|[- _])(\w)/g, (m, b, p) => b.replace(b, p.toUpperCase()));

/**
 * Turns the first letter of the string uppercase (eg. "testing string" -> "Testing string")
 *
 * @param {string} str - Capitalizes a sting
 * @returns {string} - The capitalized string
 */
const capitalize = str => str ? `${str[0].toUpperCase()}${str.slice(1)}` : '';

export { capitalize, pascalCase };
